
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"6.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Feature","transform":"translate(-684 -419)","fill":"#777a8d"}},[_c('path',{attrs:{"id":"Path_20068","data-name":"Path 20068","d":"M11.875 14.5h-8.75A3.129 3.129 0 010 11.375v-.25A3.129 3.129 0 013.125 8h8.75A3.129 3.129 0 0115 11.125v.25a3.129 3.129 0 01-3.125 3.125zm-8.75-5.25a1.875 1.875 0 00-1.875 1.875v.25a1.875 1.875 0 001.875 1.875h8.75a1.875 1.875 0 001.875-1.875v-.25a1.875 1.875 0 00-1.875-1.875z","transform":"translate(684 411)"}}),_c('path',{attrs:{"id":"Path_20069","data-name":"Path 20069","d":"M9.625 17.25h-5a.625.625 0 010-1.25h5a.625.625 0 010 1.25z","transform":"translate(682.5 405.75)"}}),_c('path',{attrs:{"id":"Path_20070","data-name":"Path 20070","d":"M17.875 17.25h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25z","transform":"translate(678 405.75)"}})])])
          )
        }
      }
    